import  {  /*useEffect,*/ useEffect, useState } from 'react';
import {
    Box,
    Button,
    TextInput,
    NumberInput,
    Group,
    Title,
    Notification,
    Loader,
    Container,
    Select,
} from '@mantine/core';
import {  IconAlertCircle } from '@tabler/icons-react';
import { useNavigate, useParams } from 'react-router-dom';
import {  /*makeGetRequest,*/ makeGetRequest, makePostRequest } from '../services/httpHelper';
import { isErrorObject } from '../utils/utils';
import ErrorHandler from '../services/ErrorHandler';
import PaymentMethodSelect from './PaymentMethodSelect';
import { IBank } from '../types';
//import { ICampaignAdmin } from '../types';





const WithdrawalForm = () => {
    const [amount, setAmount] = useState<number | undefined>(undefined);
    //const [paymentMethod, setPaymentMethod] = useState<'mpesa' | 'bank' | ''>('');
    const [paymentMethod, setPaymentMethod] = useState('');

    const [mpesaNumber, setMpesaNumber] = useState<string>('');
    const [mpesaName, setMpesaName] = useState<string>('');
    const [bankAccountNumber, setBankAccountNumber] = useState<string>('');
    const [bankAccountName, setBankAccountName] = useState<string>('');
    const [bankName, setBankName] = useState<string>('');
    const [bankCode, setBankCode] = useState<string>('');
    const [branch, setBranch] = useState<string>('');
    const [country, setCountry] = useState<string>('');

    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [banks, setBanks] = useState<IBank[]>([]);
    
   // const [admins, setAdmins] = useState<ICampaignAdmin[]>([]);


    


    const {id} = useParams();
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const navigate = useNavigate();


      
    const getBanks = async () => {
        setIsLoading(true);
        const res = await makeGetRequest('banks');

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            const results = res.data;
            setBanks(results);       
            setIsLoading(false);
            setError(null);
        }
    };

  

    const getCampaignBank = async () => {
        setIsLoading(true);
        const res = await makeGetRequest(`bank/campaign/${id}`);

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            const result = res.data;
            if(result){
                setBankName(result.bank.bank_name)
                setBankAccountName(result.accountDetail.account_name)
                setBankAccountNumber(result.accountDetail.account_number)
                setBankCode(result.bank.bank_code)
                setCountry(result.bank.country)
                setBranch(result.accountDetail.branch)
                setError(null);

            }
          
           
        }
    };

    const getCampaignMpesaNumber = async () => {
        setIsLoading(true);
        const res = await makeGetRequest(`mpesa-number/campaign/${id}`);

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            const result = res.data;
            if(result){
                setMpesaNumber(result.mpesa_number)
                setMpesaName(result.mpesa_name)
               
                setError(null);

            }
          
           
        }
    };

 

  


    const handleSubmit = async()=>{
            
       if(!amount){
        setError('Please enter amount');
                return;
       }

       if(!paymentMethod){
        setError('Choose account type');
                return;
       }
        if (paymentMethod === 'mpesa') {
            if (!mpesaNumber) {
                setError('Please enter  M-PESA number.');
                return;
            }
        } else if (paymentMethod === 'bank') {
            if (!bankName) {
                setError('Please select your bank');
                return;
            }
            if (!bankAccountName) {
                setError('Please enter bank account name');
                return;
            }
            if (!bankAccountNumber) {
                setError('Please enter bank account number');
                return;
            }
          
        }
        const res = await makePostRequest(`initiate-withdrawal`,{
            campaignId:id,
            amount:amount,
            paymentMethod:paymentMethod,
            mpesaNumber:mpesaNumber,
            mpesaName:mpesaName,
            bankName:bankName,
            bankAccountNumber:bankAccountNumber,
            bankAccountName:bankAccountName,
            bankCode:bankCode,
            branch:branch,
            country:country,
            userId:user.id
        });

        if (isErrorObject(res)) {
            setIsLoading(false);
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            navigate(`/verify-withdrawal-initiator/${id}?wi=${res.data}`,{state:{withdrawalId:res.data}})
          
        }
    
   
   

}

const handleBankChange = (value: string) => {
    setBankName(value);
 
};

    const handleWithdrawalAmount = (value: number | any) => {
        const amount = value ?? 0;
        setAmount(amount);
        
    };
    const handlePaymentMethod =(ptmMethod:string)=>{

        setPaymentMethod(ptmMethod)
        if(ptmMethod==='Bank'){
            //retrive campaign bank
            getCampaignBank()

        }else{

            getCampaignMpesaNumber()
        }

    }

    /*const fetchAdmins = async () => {
        const res = await makeGetRequest(`campaign-admins/${id}`);
        setIsLoading(false);
        if (isErrorObject(res)) {
            const errorMessage = ErrorHandler(res);
            setError(errorMessage);
        } else {
            setAdmins(res.data);
        }
    };*/

    /*const userHasAccess =()=>{
        if(user.id===id){
          return true;
      
        }
        if(admins.length){
          const inAdmins = admins.filter((admin)=>admin.user.id===user.id);
          if(inAdmins){
            return true
          }
        
         
        }
         return false;
      
      }*/


   /* useEffect(()=>{
        fetchAdmins();
        const hasAccess= userHasAccess();
        if(!hasAccess){
            navigate('/unauthorized')
        }


    },[id])*/

    useEffect(()=>{
        getBanks()
    },[])



    return (
        <Box  mx="auto">
            <Container>
            {isLoading && <Loader/>}
            {error && <p className='error'>{error}</p>}
            <Title order={3} align="center" mb="lg">Withdrawal Request</Title>
            {error && (
                <Notification icon={<IconAlertCircle size={18} />} color="red" mb="lg">
                    {error}
                </Notification>
            )}
           
            

                      
            <NumberInput
                size='md'
                label="Withdrawal Amount"
                placeholder="Enter amount"
                precision={2}
                value={amount}
                onChange={handleWithdrawalAmount}
                min={0}
                required
            />
          
            <PaymentMethodSelect value={paymentMethod} onChange={handlePaymentMethod}/>
            {paymentMethod === 'M-PESA' && (
                <TextInput
                    disabled={true}
                    label="M-PESA Number"
                    placeholder="Enter M-PESA number"
                    value={mpesaNumber}
                    onChange={(e) => setMpesaNumber(e.currentTarget.value)}
                    required
                />
            )}
            {paymentMethod === 'Bank' && (
             <>
            <Select
            disabled={true}
             label="Bank Name"
             value={bankName}
             onChange={handleBankChange}
             data={banks.map(bank => ({ value: bank.bank_name, label: `${bank.bank_name} ` }))}
                                     />
                 
                               
                 
                                     
              {/* <TextInput
                    label="Bank Name"
                    placeholder="Enter name of the bank"
                    value={bankName}
                    onChange={(e) => setBankName(e.currentTarget.value)}
                    required
                />*/}
                <TextInput
                    disabled={true}
                    label="Bank Account"
                    placeholder="Enter bank account number"
                    value={bankAccountNumber}
                    onChange={(e) => setBankAccountNumber(e.currentTarget.value)}
                    required
                />

                <TextInput
                    disabled={true}
                    label="Bank Account Name"
                    placeholder="Enter bank account name"
                    value={bankAccountName}
                    onChange={(e) => setBankAccountName(e.currentTarget.value)}
                    required
                />
             </>
            )}
            <Group position="right" mt="lg">
                <Button onClick={handleSubmit}>Submit Withdrawal</Button>
            </Group>

            </Container>
           
        </Box>
    );
};

export default WithdrawalForm;
